import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Tabs from "@material-ui/core/Tabs";
import Tooltip from "@material-ui/core/Tooltip";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import { withSnackbar } from "notistack";
import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getFormattedImageLink, getFormattedDate } from "Utils";
import Paper from "@material-ui/core/Paper";
import SearchSq from "Component/Material-ui/SearchSq";
import IconWithBackground from "Component/Icons/iconWithBackground";
import addPlusIcon from "Assets/newicons/action/add-plus/outline/add-plus-outline-16px.svg";
import policyoutlined from "Assets/newicons/document/policy/outline/policy-outline-16px.svg";
// import {  } from "./Functions";
import { FormStatus, getPartiCipant, getStatus } from "./Functions";
// import filterIcon from "Assets/newicons/action/filter/outline/filter-outline-16px.svg";

const styles = () => ({
  TableRow: {
    borderRadius: 4,
  },
  customWidth: {
    maxWidth: 300,
    height: "auto",
    maxHeight: "200px !important",
  },
});

class EmpList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const {
      tabId,
      searchValue,
      empList,
      selectedempid,
      isSpecialAccess,
      classes,
      selectedemp,
      isoverview,
    } = this.props;

    return (
      <Grid item md={3} sm={12}>
        <Paper
          className="rounded-rectangle-paper thin-scroll"
          style={{ height: "65vh", boxSizing: "border-box", overflowY: "auto" }}
        >
          <VerticalTabs
            value={tabId}
            // onChange={this.handleChange.bind(this, tabId)}
            indicatorColor="primary"
            textColor="primary"
            className="right-border"
          >
            <div style={{ padding: "16px 16px 16px 16px" }}>
              <p className="extra-small-dark-secondary t-bold margin-bottom-8">
                Participants
              </p>
              {isSpecialAccess && (
                <div>
                  <div
                  // style={{
                  //   width: "75%",
                  //   float: "left",
                  //   marginRight: 8,
                  // }}
                  >
                    <SearchSq
                      placeholder="Search"
                      value={searchValue}
                      onChange={this.props.handleSearch}
                    />
                  </div>
                  {/* {selectedemp &&
                    selectedemp.statusid != 2 &&
                    selectedemp.actions &&
                    selectedemp.actions.isadhoc && (
                      <div
                        className="floatright"
                        onClick={this.props.setAddHoc}
                      >
                        <IconWithBackground imgsrc={addPlusIcon} />
                      </div>
                    )} */}
                  {/* <div className="floatleft">
                  <IconWithBackground imgsrc={filterIcon} />
                </div> */}
                </div>
              )}
              {!isSpecialAccess && (
                <SearchSq
                  placeholder="Search employee"
                  value={searchValue}
                  onChange={this.props.handleSearch}
                />
              )}
            </div>
            <div
              className={
                isoverview
                  ? "vertical-tab-item-selected padding-left-16 padding-right-16 display-flex"
                  : "vertical-tab-item padding-left-16 padding-right-16 display-flex"
              }
              style={{ alignItems: "center", paddingBottom: 8 }}
              onClick={() => this.props.getoverview()}
            >
              <div
                className="margin-right-16"
                style={{
                  width: 32,
                  height: 32,
                  background: "#EDF5FD",
                  border: "1px solid #FFFFFF",
                  borderRadius: 20,
                  position: "relative",
                }}
              >
                <img src={policyoutlined} className="vertical-center"></img>
              </div>
              <span className="small-dark-secondary">Overview</span>
            </div>
            <div
              className="thin-scroll"
              style={{ overflowY: "auto", maxHeight: "70vh" }}
            >
              {empList &&
                empList.map((emp) => (
                  <div
                    key="key"
                    label="Reviews"
                    onClick={() => this.props.getEmpForms(emp)}
                    className={`${
                      selectedempid &&
                      !isoverview &&
                      (isSpecialAccess
                        ? selectedempid == emp.empreviewdetailid
                        : selectedempid == emp.employeeid)
                        ? "vertical-tab-item-selected"
                        : "vertical-tab-item"
                    } padding-left-16 padding-right-16`}
                    // style={{ display: emp.skippartcipant ? "none" : "block" }}
                  >
                    <div>
                      <div className="display-flex">
                        <div className=" margin-right-16">
                          <ProfilePicture
                            src={getFormattedImageLink(emp.imagepath)}
                            height="32"
                          />
                        </div>
                        <div className=" margin-bottom-8">
                          <span className="small-dark-secondary display-block">
                            {emp.fullname}
                          </span>
                          {emp.participanttypeid && (
                            <span
                              className="extra-small-dark-secondary"
                              style={{ fontSize: 12 }}
                            >
                              {getPartiCipant(emp.participanttypeid)}
                            </span>
                          )}
                          {/* <span
                    className="extra-small-dark-secondary"
                    style={{ fontSize: 12 }}
                  >
                    3 pending
                  </span> */}
                        </div>
                        {/* {(emp.skiprating || emp.skippartcipant) && ( */}
                        {isSpecialAccess && (
                          <div className="">
                            <Tooltip
                              title={
                                <span>
                                  {
                                    <span className="t-backgroundColor display-block">
                                      Close date :{" "}
                                      {getFormattedDate(emp.closedate)}
                                    </span>
                                  }
                                  {
                                    <p
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        marginTop: 2,
                                      }}
                                    >
                                      <p className=" extra-small-dark t-bold">
                                        {" "}
                                        Status:{" "}
                                      </p>
                                      <p
                                        className="small-dark-secondary t-bold"
                                        style={{
                                          paddingLeft: 2,
                                          color:
                                            getStatus(emp) == FormStatus.SUBMIT
                                              ? "#008985"
                                              : getStatus(emp) ==
                                                FormStatus.RELEASE
                                              ? "#A9A9A9"
                                              : getStatus(emp) ==
                                                FormStatus.OPEN
                                              ? "#1e8ced"
                                              : getStatus(emp) ==
                                                FormStatus.OPENDRAFT
                                              ? "#1e8cee"
                                              : getStatus(emp) ==
                                                FormStatus.CLOSED
                                              ? "#ff4052"
                                              : // : getStatus(emp) ==
                                                //   FormStatus.DUESOON
                                                // ? "#ad0e46"
                                                "#ad0e46",
                                        }}
                                      >
                                        {getStatus(emp)}
                                      </p>
                                    </p>
                                  }
                                  {emp.skiprating && (
                                    <span className="t-backgroundColor display-block">
                                      - Exclude average ratings{emp.skipratingbydetails}
                                    </span>
                                  )}

                                  {emp.skippartcipant && (
                                    <span className="t-backgroundColor margin-top-4">
                                      - Skip participant{emp.skipparticipantbydetails}
                                    </span>
                                  )}
                                  <br />
                                </span>
                              }
                              placement="right"
                              classes={{
                                tooltip: classes.customWidth,
                              }}
                            >
                              <span>
                                <i
                                  className="material-icons"
                                  style={{ color: "#ddd", cursor: "default" }}
                                >
                                  info
                                </i>
                              </span>
                            </Tooltip>
                          </div>
                        )}
                        {/* )} */}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </VerticalTabs>
        </Paper>
      </Grid>
    );
  }
}

const VerticalTabs = withStyles(() => ({
  flexContainer: {
    flexDirection: "column",
  },
  indicator: {
    display: "none",
  },
}))(Tabs);

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(EmpList)));
